export default "__VITE_ASSET__BlOQMKt2__"